/* src/app/system-utils/file-loader/file-loader.component.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.file-upload-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;
  font-family: var(--tem-font-family);
}
.file-upload-header {
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  padding: 10px;
  border: 1px solid var(--tem-border);
  background: var(--tem-surface-2);
  border-top-right-radius: var(--tem-radius);
  border-top-left-radius: var(--tem-radius);
  color: var(--tem-ink);
}
.file-upload-header p {
  color: var(--tem-muted);
  margin: 0;
}
.tool-bar {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  margin-top: 10px;
  padding: var(--tem-space-2) var(--tem-space-3);
  background: var(--tem-surface-2);
  border: 1px solid var(--tem-border);
  border-radius: var(--tem-radius);
}
.list-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: auto;
  margin-top: 8px;
}
.item-file-upload {
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 10px;
  align-items: center;
  min-height: 44px;
  padding: 0 10px;
  border-radius: var(--tem-radius);
  color: var(--tem-ink);
}
.item-file-upload:nth-child(even) {
  background: var(--tem-surface-2);
}
.item-file-upload-info {
  width: 70%;
  text-overflow: ellipsis;
  overflow: hidden;
  word-spacing: unset;
  display: flex;
  flex-direction: row;
  gap: 5px;
}
.progress-bar {
  width: 30%;
}
.file-upload-footer {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border-top: 1px solid var(--tem-border);
  color: var(--tem-muted);
}
.cancel-upload {
  cursor: pointer;
  color: var(--tem-muted);
}
.cancel-upload:hover {
  color: var(--tem-danger, #ff4d4f);
}
.done-upload {
  color: #52c41a;
}
.waiting-upload {
  color: #faad14;
}
.error-upload {
  color: var(--tem-danger, #ff4d4f);
}
/*# sourceMappingURL=file-loader.component.css.map */
